<template>
<div style="display: inherit">
  <a @click="showNewDialog"
    class="navbar-item router-link-exact-active router-link-active">
    <b-icon class="is-hidden-desktop menu-icon" icon="shopping-cart"/>
    {{$t('new')}}
  </a>

  <a @click="showOpenDialog"
    class="navbar-item router-link-exact-active router-link-active">
    <b-icon class="is-hidden-desktop menu-icon" icon="folder-open"/>
    {{$t('openButton')}}
  </a>

  <a @click="showConfirmDelete"
    v-if="currentShoppingList"
    class="navbar-item router-link-exact-active router-link-active">
    <b-icon class="is-hidden-desktop menu-icon" icon="trash"/>
    {{$t('delete')}}
  </a>

</div>
</template>

<i18n src="@/i18n/global.i18n.json"></i18n>

<script>
import { mapGetters } from 'vuex';
import i18nMixin from '@/mixins/i18n';
import routingMixin from '@/mixins/routing';
import { DELETE_LIST } from '@/graphql/shopping-list';
import ShoppingListModalNew from './ShoppingListModalNew';
import ShoppingListModalOpen from './ShoppingListModalOpen';

export default {
  name: 'shoppingListAppToolbar',
  mixins: [i18nMixin, routingMixin],
  computed: {
    ...mapGetters('shoppingList', ['currentShoppingList']),
  },
  methods: {
    showNewDialog() {
      this.$modal.open({
        parent: this,
        component: ShoppingListModalNew,
        hasModalCard: true,
        events: {
          ok: shoppingList => this.routeShoppingList(shoppingList),
        },
      });
    },

    showOpenDialog() {
      this.$modal.open({
        parent: this,
        component: ShoppingListModalOpen,
        hasModalCard: true,
        events: {
          ok: shoppingList => this.routeShoppingList(shoppingList),
        },
      });
    },

    showConfirmDelete() {
      this.$dialog.confirm({
        title: `Delete "${this.currentShoppingList.name}"`,
        message: 'Are you sure? This cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$apollo.mutate({
            mutation: DELETE_LIST,
            variables: {
              id: this.currentShoppingList.id,
            },
          }).then(({ data: { shoppingListDelete } }) => {
            this.routeShoppingList(shoppingListDelete.defaultList);

            this.$toast.open({
              message: `Deleted ${shoppingListDelete.deletedList.name}`,
              type: 'is-success',
            });
          });
          // TODO handleError
        },
      });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/shopping-list/ShoppingListAppToolbar.vue